export const CONTEXT_CONSTS = {
  moduleName: 'epb-context',

  getters: {
    context: 'context',
    enabledFilters: 'enabledFilters',
    appliedFiltersCount: 'appliedFiltersCount',
    filtersAreValid: 'filtersAreValid'
  },
  actions: {
    setContext: 'setContext',
    setFiltersSelectedValues: 'setFiltersSelectedValues',
    clearFilters: 'clearFilters',
    setQuery: 'setQuery',
    clearModule: 'clearModule'
  },
  mutations: {
    setContext: 'setContext',
    clearModule: 'clearModule'
  }

};
